export default "__VITE_ASSET__a14bac0d__"